import { Slide } from "react-reveal";
import FaqCard from "../reusables/FaqCard";
import FaqCardList from "../reusables/FaqCardList";
import OtherFAQs from "../reusables/OtherFAQs";

const BrandingFaqsBody = () => {
  return (
    <section className="faqs section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head center width-600 margin-auto section-spacing-50 no-padding-top">
              <p className="section-tag boldTitle">FAQS</p>
              <Slide top>
                <h2 className="section-title ntuna-text-fill">
                  Frequently Asked Questions
                </h2>
              </Slide>
            </div>
            <div className="section-body">
              <ul className="faqs-container width-600 margin-auto">
                <FaqCardList faq="What is the difference between a logo and a brand identity?">
                  <p>A logo is just one element. A brand identity includes:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Logo</span>
                    </li>
                    <li>
                      <span>Colors</span>
                    </li>
                    <li>
                      <span>Typography</span>
                    </li>
                    <li>
                      <span>Visual style</span>
                    </li>
                    <li>
                      <span>Messaging direction</span>
                    </li>
                  </ul>
                  <p>
                    A logo identifies you. A brand identity defines how people
                    perceive you.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Why is branding important for my business?">
                  <p>
                    Your brand affects how customers see and trust you. Strong
                    branding helps you:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Look professional</span>
                    </li>
                    <li>
                      <span>Stand out from competitors</span>
                    </li>
                    <li>
                      <span>Build trust instantly</span>
                    </li>
                    <li>
                      <span>Attract better clients</span>
                    </li>
                  </ul>
                  <p>
                    People judge your business visually before anything else.
                  </p>
                </FaqCardList>
                <FaqCardList faq="How do you ensure the design matches my business?">
                  <p>We start with:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Business discovery</span>
                    </li>
                    <li>
                      <span>Audience understanding</span>
                    </li>
                    <li>
                      <span>Brand positioning</span>
                    </li>
                  </ul>
                  <p>Then we design based on strategy—not guesswork.</p>
                </FaqCardList>
                <FaqCardList faq="Will I be involved in the design process?">
                  <p>Yes. You’ll:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Review concepts</span>
                    </li>
                    <li>
                      <span>Give feedback</span>
                    </li>
                    <li>
                      <span>Approve final designs</span>
                    </li>
                  </ul>
                  <p>
                    It’s a collaborative process to ensure the result fits your
                    vision.
                  </p>
                </FaqCardList>
                <FaqCardList faq="How many design concepts will I receive?">
                  <p>
                    We provide carefully developed concepts based on
                    strategy—not random options. The focus is on quality and
                    alignment, not quantity.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Can I request revisions?">
                  <p>
                    Yes. We refine designs based on your feedback to ensure:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Alignment with your vision</span>
                    </li>
                    <li>
                      <span>Professional quality</span>
                    </li>
                    <li>
                      <span>Consistency</span>
                    </li>
                    <li>
                      <span>Your satisfaction</span>
                    </li>
                  </ul>
                  <p>
                    The goal is a result you’re fully confident in and love.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will I fully own my logo and brand assets?">
                  <p>Yes. Once the project is completed:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>You receive full ownership</span>
                    </li>
                    <li>
                      <span>All final files are delivered</span>
                    </li>
                  </ul>
                  <p>Your brand is 100% yours.</p>
                </FaqCardList>
                <FaqCardList faq="What files will I receive?">
                  <p>You’ll get:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>High-resolution logo files</span>
                    </li>
                    <li>
                      <span>Vector files (for scaling)</span>
                    </li>
                    <li>
                      <span>Web and print formats</span>
                    </li>
                    <li>
                      <span>Brand assets and guidelines</span>
                    </li>
                  </ul>
                  <p>Ready files for any use—digital or print.</p>
                </FaqCardList>
                <FaqCardList faq="Can you redesign or improve my existing brand?">
                  <p>Yes. We can:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Refresh your visual identity</span>
                    </li>
                    <li>
                      <span>Modernize your logo</span>
                    </li>
                    <li>
                      <span>Improve consistency</span>
                    </li>
                  </ul>
                  <p>Without losing your brand recognition.</p>
                </FaqCardList>
                <FaqCardList faq="How long does a branding project take?">
                  <p>It depends on scope:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Basic branding: A day - week</span>
                    </li>
                    <li>
                      <span>Full brand identity: 2–4 weeks</span>
                    </li>
                  </ul>
                  <p>Timelines are clearly defined before we start.</p>
                </FaqCardList>
                <FaqCardList faq="Do you design for both digital and print?">
                  <p>Yes. We create designs for:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Social media</span>
                    </li>
                    <li>
                      <span>Websites</span>
                    </li>
                    <li>
                      <span>Print materials (flyers, cards, etc.)</span>
                    </li>
                  </ul>
                  <p>Your brand stays consistent everywhere.</p>
                </FaqCardList>
                <FaqCardList faq="Can you help with ongoing design needs?">
                  <p>Yes. We provide:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Continuous design support</span>
                    </li>
                    <li>
                      <span>Campaign creatives</span>
                    </li>
                    <li>
                      <span>New materials as your business grows</span>
                    </li>
                  </ul>
                  <p>Your brand evolves with you.</p>
                </FaqCardList>
                <FaqCardList faq="What makes NTUNA.COM different from other designers?">
                  <p>We don’t just design — we build brand systems.</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Strategy-driven approach</span>
                    </li>
                    <li>
                      <span>Focus on consistency and impact</span>
                    </li>
                    <li>
                      <span>Designed for business growth</span>
                    </li>
                  </ul>
                  <p>
                    You’re not getting random visuals—you’re building a brand.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Is branding worth the investment?">
                  <p>Yes—because it directly affects:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Trust</span>
                    </li>
                    <li>
                      <span>Perception</span>
                    </li>
                    <li>
                      <span>Customer decisions</span>
                    </li>
                  </ul>
                  <p>
                    A strong brand can significantly increase your business
                    value.
                  </p>
                </FaqCardList>
                <FaqCardList faq="How do I/we get started?">
                  <p>
                    Simply{" "}
                    <a
                      href="/contacts"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      contact us
                    </a>{" "}
                    or book a{" "}
                    <a href="/#" target="_blank" rel="noopener noreferrer">
                      consultation
                    </a>
                    . We’ll:
                  </p>
                  <ul className="faq-olist">
                    <li>
                      <span>Understand your needs</span>
                    </li>
                    <li>
                      <span>Define your brand direction</span>
                    </li>
                    <li>
                      <span>Agree on fee so you can make initial deposit</span>
                    </li>
                    <li>
                      <span>Begin design</span>
                    </li>
                  </ul>
                </FaqCardList>

                <FaqCard
                  faq="Do you offer payment plans?"
                  answer="Yes. We offer flexible payment plans to make it easier for clients to invest in the efficiency and growth of their businesses and institutions."
                />
              </ul>
            </div>
            <OtherFAQs/>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandingFaqsBody;
